import CheckboxInverted from './checkboxInverted';

export default CheckboxInverted;
